export enum CholesterolUnit {
    Metric = 'mmol/L',
    Imperial = 'mg/dL'
}
